import { agreeUsingPOST } from 'apis/account-controller';
import { Modal } from 'm-ui';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUserInfo, globalAction } from 'store/global';
import './index.less';

const Agreement = () => {
  const userInfo = useSelector((state) => state.global.userInfo);
  const agreementVisible = useSelector((state) => state.global.agreementVisible);
  const [step, setStep] = useState(0);
  const [agreeLoading, setAgreeLoading] = useState(false);
  const dispatch = useDispatch();
  const onOk = async () => {
    try {
      if (step === 0) {
        setStep(1);
        return;
      }
      if (!userInfo?.inavadAccountInfo.agreement) {
        setAgreeLoading(true);
        await agreeUsingPOST();
        dispatch(fetchUserInfo());
        setAgreeLoading(false);
      }
      dispatch(globalAction.setAgreementVisible(false));
      setStep(0);
    } catch (error) {
      setAgreeLoading(false);
      setStep(0);
    }
  };
  const okText =
    step === 0 ? '下一步' : userInfo?.inavadAccountInfo.agreement ? '确认' : '我已知晓，开始使用';

  return (
    <>
      <Modal
        title="使用协议"
        closable={false}
        maskClosable={false}
        okText={okText}
        cancelButtonProps={{
          style: {
            display: 'none',
          },
        }}
        confirmLoading={agreeLoading}
        width={1200}
        bodyStyle={{ maxHeight: '1000px' }}
        visible={agreementVisible}
        onOk={onOk}
        className="ant-modal-large"
      >
        <p>欢迎使用互动平台，开始使用前，请先阅读并统一平台使用协议以及特别提示。</p>
        {step === 0 && (
          <iframe
            width="100%"
            height="700px"
            scrolling="no"
            src={userInfo?.inavadAccountInfo.protocolUrl}
            frameBorder="0"
            title="本地预览"
          />
        )}
        {step === 1 && (
          <iframe
            width="100%"
            height="700px"
            scrolling="no"
            src={userInfo?.inavadAccountInfo.specialPoint}
            frameBorder="0"
            title="本地预览"
          />
        )}
      </Modal>
    </>
  );
};

export default Agreement;
